<template>
  <!-- Sticker-Auswahl im Stil der Status-Auswahl: farbige Pillen in Liste und Feld -->
  <v-select class="record-tag-select" multiple :options="options" :value="selected" label="name" :placeholder="placeholder" :close-on-select="false" @input="(val) => $emit('input', val.map((t) => t.name))">
    <template #option="option">
      <md-chip :style="chipStyle(option.color)">{{ option.name }}</md-chip>
    </template>
    <template #selected-option="option">
      <md-chip :style="chipStyle(option.color)">{{ option.name }}</md-chip>
    </template>
  </v-select>
</template>
<script>
export default {
  name: "RecordTagSelect",
  props: {
    value: { type: Array, default: () => [] },
    placeholder: { type: String, default: "" },
  },
  computed: {
    options() {
      return this.$store.state.shippingData.recordTags || [];
    },
    selected() {
      return this.value.map((name) => this.options.find((t) => t.name === name) || { name });
    },
  },
  methods: {
    chipStyle(color) {
      const bg = color || "#999";
      return `background-color: ${bg} !important; color: ${this.contrastingTextColor(bg)} !important`;
    },
    contrastingTextColor(hex) {
      const c = (hex || "").replace("#", "");
      if (c.length !== 6) return "#fff";
      const luma = (0.299 * parseInt(c.substring(0, 2), 16) + 0.587 * parseInt(c.substring(2, 4), 16) + 0.114 * parseInt(c.substring(4, 6), 16)) / 255;
      return luma > 0.6 ? "#000" : "#fff";
    },
  },
};
</script>
<style>
.record-tag-select .vs__selected {
  background: transparent;
  border: 0 none;
  padding: 0;
  margin: 2px 4px 2px 0;
}
.record-tag-select .vs__selected .md-chip {
  margin: 0;
}
</style>
